import React from 'react';
import { isKg, formatQty, lineTotal, effectivePrice } from '../utils/units';
import { brl } from '../utils/format';
import ProductList from './ProductList';

function Cart({ cart, onRemove, onUpdateQuantity, onCheckout, onBack, suggestions = [], onAddToCart, inCart }) {
  const total = cart.reduce((sum, item) => sum + lineTotal(item), 0);

  return (
    <div className="cart">
      <div className="cart-head">
        <h2>Seu Carrinho</h2>
        <button className="cart-back" onClick={onBack}>← Continuar comprando</button>
      </div>
      {cart.length === 0 ? (
        <>
          <p className="cart-empty">Seu carrinho está vazio. Que tal começar por aqui? 👇</p>
          {suggestions.length > 0 && (
            <ProductList
              title="⭐ Os mais pedidos"
              products={suggestions}
              onAddToCart={onAddToCart}
              onUpdateQuantity={onUpdateQuantity}
              inCart={inCart}
              row
            />
          )}
        </>
      ) : (
        <>
          <div className="cart-items">
            {cart.map(item => {
              const step = isKg(item.unit) ? 0.05 : 1;
              return (
              <div key={item.id} className="cart-item">
                <div className="item-info">
                  <h4>{item.name}</h4>
                  <p>
                    {isKg(item.unit)
                      ? `${brl(effectivePrice(item))}/kg × ${formatQty(item.quantity, item.unit)} = ${brl(lineTotal(item))}`
                      : `${brl(effectivePrice(item))} x ${item.quantity} = ${brl(lineTotal(item))}`}
                  </p>
                </div>
                <div className="item-controls">
                  <button onClick={() => onUpdateQuantity(item.id, item.quantity - step)}>-</button>
                  <span>{isKg(item.unit) ? formatQty(item.quantity, item.unit) : item.quantity}</span>
                  <button onClick={() => onUpdateQuantity(item.id, item.quantity + step)}>+</button>
                  <button className="remove-btn" onClick={() => onRemove(item.id)}>Remover</button>
                </div>
              </div>
              );
            })}
          </div>
          <div className="cart-summary">
            <h3>Total: {brl(total)}</h3>
            <button className="checkout-btn" onClick={onCheckout}>Finalizar Pedido</button>
          </div>
        </>
      )}
    </div>
  );
}

export default Cart;